//Upload file
(function () {
    document.addEventListener('scrollTop', function (event) {
        selector  = document.getElementById("main-form-statement");
        var positions = elementPosition(selector);
        window.scrollTo(
            {
                top: positions.clientY,
                left: 0,
                behavior: 'smooth'
            }
        );
    });
    function elementPosition (a) {
        var b = a.getBoundingClientRect();
        return {
          clientX: a.offsetLeft,
          clientY: a.offsetTop,
          viewportX: (b.x || b.left),
          viewportY: (b.y || b.top)
        }
      }    
})();
